import { distinctUntilChanged } from "rxjs";
import { CdpaButtonComponent, CdpaButtonId } from "../../common/components/cdpaButton.component";
import { CdpaInputComponent, CdpaInputId } from "../../common/components/cdpaInput.component";
import { enableEmailRestoring } from "./formHelpers/emailRestoreHelpers";
import { attachValidationOnSubmitClick } from "./formHelpers/formHelpers";
import { ValidityState } from "../../common/components/validators/baseValidator";
import { FormId } from "./common/formId";
import "./register-start.scss";
export class RegisterStart {
    constructor() {
        const emailInput = new CdpaInputComponent(CdpaInputId.Email);
        const form = document.getElementById(FormId.Start);
        const submitButton = new CdpaButtonComponent(CdpaButtonId.Continue);
        attachValidationOnSubmitClick(submitButton, form, [emailInput]);
        enableEmailRestoring("login-link", emailInput);
        enableEmailRestoring("message-login-link", emailInput);
        emailInput.validityState$.pipe(distinctUntilChanged()).subscribe((value) => {
            submitButton.setDisabled(value === ValidityState.Info);
        });
    }
}
